import"./../Carousel/Carousel.css.ts.vanilla.css";import"./ProductGallery.css.ts.vanilla.css";var r="_12zni9u1",t="_12zni9u0";export{r as productGalleryImageStyle,t as productGalleryStyle};
